import Decimal from 'decimal.js'

// a + b + c + ...
export function sum(...args) {
  let res = args.shift()
  if (res == null) res = 0

  for (let arg of args) {
    if (arg == null) arg = 0
    res = Number(Decimal(Number(res)).plus(arg))
  }

  return res
}

// a - b - c - ...
export function substract(...args) {
  let res = args.shift()
  if (res == null) res = 0

  for (let arg of args) {
    if (arg == null) arg = 0
    res = Number(Decimal(Number(res)).minus(arg))
  }

  return res
}

// a * b * c * ...
export function multiply(...args) {
  let res = args.shift()
  if (res == null) res = 0
  
  for (let arg of args) {
    if (arg == null) arg = 0
    res = Number(Decimal(Number(res)).mul(arg))
  }

  return res
}

// a / b / c / ...
export function divide(...args) {
  let res = args.shift()
  if (res == null) res = 0

  for (let arg of args) {
    if (arg == null) arg = 0
    res = Number(Decimal(Number(res)).div(arg))
  }

  return res
}
